<template>
  <section class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 relative overflow-hidden">
    <div
      class="absolute inset-0 bg-gradient-to-br from-[#0b105d] via-[#0b105d]/90 to-[#fe6d0d]/20"
    ></div>
    <div class="absolute inset-0 bg-black opacity-40"></div>

    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 relative z-10">
      <div class="max-w-4xl sm:max-w-5xl lg:max-w-6xl mx-auto">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-[#f4f4f4] mb-12 sm:mb-16"
          data-aos="fade-up"
        >
          {{ $t('aboutUsPage.magicFeaturesDetailed.title') }}
        </h2>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
          <div
            v-for="(key, index) in featureKeys"
            :key="key"
            class="group"
            data-aos="zoom-in"
            :data-aos-delay="index * 150"
          >
            <div class="relative h-full">
              <div
                class="absolute inset-0 bg-gradient-to-br from-[#fe6d0d]/20 to-[#ffb47c]/20 rounded-2xl sm:rounded-3xl blur-xl"
              ></div>
              <div
                class="relative h-full glass-morphism-dark rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-[#f4f4f4]/10 hover:border-[#f4f4f4]/20 transition-all duration-300"
              >
                <div class="flex items-start gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <ZapIcon
                    class="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-[#fe6d0d] flex-shrink-0"
                  />
                  <h3
                    class="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c]"
                  >
                    {{ $t(`aboutUsPage.magicFeaturesDetailed.${key}`).split(':')[0] }}
                  </h3>
                </div>
                <p class="text-[#f4f4f4]/90 leading-relaxed text-sm sm:text-base">
                  {{
                    $t(`aboutUsPage.magicFeaturesDetailed.${key}`)
                      .split(':')
                      .slice(1)
                      .join(':')
                      .trim()
                  }}
                </p>
                <div class="mt-4 sm:mt-6 flex justify-end">
                  <div
                    class="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#fe6d0d]/20 to-[#ffb47c]/20 rounded-full blur-xl"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ZapIcon } from 'lucide-vue-next'

const featureKeys = ['logicAndData', 'modelTrainingAndAdaptation']
</script>

<style scoped>
.glass-morphism-dark {
  background: rgba(244, 244, 244, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(244, 244, 244, 0.1);
}
</style>
